<template>
  <div class="problem">
    <div class="problem_left">
			<ul class="problem_left_title" >
				<li class="problem_left_titles">拍卖流程常见问题</li>
				<li v-for="(item,indexli) in problemtabs" :key="indexli"  @click="toggleproTabs(indexli,0)" :class='{ current : showLi == indexli && showUl == 0 }'>{{item.tab}}</li>
			</ul>
			<ul class="problem_left_title">
				<li class="problem_left_titles">拍卖规则</li>
				<li v-for="(item,indexli) in problemtabs1" :key="indexli" @click="toggleproTabs(indexli,1)" :class='{ current : showLi == indexli && showUl == 1 }'>{{item.tab}}</li>
			</ul>
			<ul class="problem_left_title">
				<li class="problem_left_titles">其他常见问题</li>
				<li v-for="(item,indexli) in problemtabs2" :key="indexli" @click="toggleproTabs(indexli,2)" :class='{ current : showLi == indexli && showUl == 2 }'>{{item.tab}}</li>
			</ul>
    <!-- <ul class="problem_left_title">
				<li class="problem_left_titles">关于拍界</li>
				<li v-for="(item,indexli) in problemtabs3" :key="indexli" @click="toggleproTabs(indexli,3)" :class='{ current : showLi == indexli && showUl == 3 }'>{{item.tab}}</li>
			</ul> -->
    </div>
    <div class="problem_right">
			<ul class="problem_right_container" v-show="showUl === 0">
				<li class="problem_right_title" >拍卖流程常见问题</li>
				<li v-show="showLi === 0">如何报名参加竞拍？<img src="@/assets/images/jingpai.png" alt=""></li>
				<li v-show="showLi === 1">什么是流拍？<p>“流拍”是指在拍卖中，由于未达到系统设置的条件，造成的拍卖交易失败。</p></li>
				<li v-show="showLi === 2">什么是标的物？<p>标的物是指当事人双方权利义务指向的对象。商业买卖合同中会有的特定名词，标的物指买卖合同中所指的物体或商品。<br> 

					举例说明，在房屋租赁中，标的物是所租赁的房屋。</p></li>
			</ul>
			<ul class="problem_right_container" v-show="showUl === 1">
				<li class="problem_right_title">拍卖规则</li>
				<li v-show="showLi === 0">保证金规则？<p>1、保证金的缴纳：<br> 
    保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金。拍界（吉林省）拍卖有限公司:{{$global.account_bank}}<span>{{$global.account_number}}</span>）。
    保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金。
					<br> 2、保证金的返还：<br>A.用户未成功竞拍商品：保证金返还时限为5个工作日。B.用户竞拍成功后，送拍人主动关闭交易或未履约发货或因商家其他原因导致交易未完成的；竞拍结束后，系统会自动在5个工作日内将款项退还到支付账号中。C.注：竞拍人缴纳的保证金仅用于履约保证，返还时不计利息，请知悉<br>3、保证金的扣除：<br>  A.在升价竞拍成功之时起的3个工作日内未按照成交价格支付货款的。 B.送拍机构主动关闭交易或未履行发货协议而导致交易未完成的。 C.标的物流拍之后，送拍人打算重新拍卖的。<br>4、保证金抵佣金：<br> 用户竞拍成功后，竞买保证金即转为成交保证金,用户完成标的交割手续后，保证金将全部或部分抵扣佣金。如保证金金额小于应支付佣金金额，用户应立即补齐；如保证金金额大于应支付佣金金额，平台将于扣除佣金后5个工作日内将剩余保证金无息返还用户。</p></li>
				<li v-show="showLi === 1">拍卖成交规则？<p>拍卖方式:<br>拍卖采取有保留价或无保留价的增价拍卖方式，每次出价金额必须是加价幅度规定金额的整数倍。<br>1.有保留价：<br>（1） 保留价大于起拍价：至少一人报名且出价不低于保留价，方可成交，出价低于保留价时，标的流拍;<br>（2） 保留价等于起拍价：①一人报名，即视为接受标的底价，已满足成交条件，即可成交。②无人报名，标的流拍。③两人或两人以上报名，均未出价，最先报名成功者判定为买受人。<br>2.无保留价:①一人报名，即视为接受标的底价，已满足成交条件，即可成交。②无人报名，标的流拍。③两人或两人以上报名，均未出价，最先报名成功者判定为买受人。<br>【注】在拍卖状态下为了防止恶意抬价，第一个出价人限制自己加价,需等其他竞拍人出价后,才能继续出价.</p></li>
				<li v-show="showLi === 2">拍卖延时规则？<p>1)出价延时的概念<br> 出价延时是指，当标的物的竞拍时间只剩最后1分钟时，如果有竞买人出价竞拍，那么系统将会自动延长拍品的竞拍时间。<br>2)出价延时的基本规则<br>在设置了出价延时的拍品竞拍结束的前1分钟（以系统接受竞价的时间显示为准），如果有竞买人出价竞拍，那么该次拍卖时间在此次出价的时间的基础上自动延时1分钟，循环往复直到没有竞买人出价竞拍时，拍卖结束。<br>3)出价延时举例说明<br>比如：假设某件拍品的拍卖结束时间是8月8日22点整，如果在8月8日21点58分15秒，有竞买人出价，那么系统将拍卖结束时间自动延长至8月8日22点02分15秒；如果在22点03分有竞买人出价，那么系统将自动延时到22点05分……以此类推，直到最后两分钟没有新的竞买人出价，那么该拍品的竞拍结束。<br>4)出价延时的效果<br>出价延时给拍卖用户带来的便利包括以下几点：<br>  1.将给到竞买人更加充分的参与竞拍的机会。<br>2.避免因为网络或者电脑原因导致的延迟而错失出价机会。</p></li>
			  <li v-show="showLi === 3">重新拍卖规则？<p>参重新拍卖是指拍卖成交后，发现有下列情形的，处置方可以决定重新拍卖。<br>1)买受人未支付价款致使拍卖目的难以实现的；<br>2)竞买人之间恶意串通的；<br>3)其他违反有关法律规定应当重新拍卖的。</p></li>
			</ul>
			<ul class="problem_right_container" v-show="showUl === 2">
				<li class="problem_right_title">其他常见问题</li>
				<li v-show="showLi === 0">悔拍怎么办？<p>竞拍成功前您的保证金是会转账到拍卖机构的指定账户中，如果竞拍到了商品没有付尾款的话，买受人悔拍后保证金不予退还。</p></li>
				<li v-show="showLi === 1">如何办理资产交割？<p>竞买人竞买成功之后，在“我的竞拍”-“我的中心”-“我的订单”里查询应该补缴的货物尾款（账户信息与缴纳保证金账户信息一致）；付完尾款之后，竞买人凭相关证件及付款凭证在3个工作日内与送拍人办理相关的资产交割手续，在此期间平台方将在线下给予相应的支持。</p></li>
			</ul>
			<!-- <ul class="problem_right_container" v-show="showUl === 3">
				<li class="problem_right_title">关于拍界</li>
				<li v-show="showLi === 0">
					<p>由中国拆迁网设计打造的全国性综合型网络拍卖平台国内更专业更齐全的拍卖平台，秉承拍卖物品质量第一的经营理念，无数物品以及资产，包罗万象，您既可以作为拍卖方，也可以作为竞拍者，卖到最开心的价格，买到最放心的产品。物资拍卖，一网打尽！</p>
					<p>金三银四希望季，2020年4月由吉林省崇晟科贸有限公司开发的拍界平台被中国拍卖行业协会正式纳入中国拍卖协会会员，截止4月7日之前拍卖协会秘书处对提出入会申请企业的资料进行了审核，协会接受商务部、民政部和国资委监督与支持，经过多位董事严格的层层筛选，最终确定了拍界的各项资质都均已符合中国拍卖协会的要求，并获得此项殊荣！</p>
					<p>中国拍卖行业协会，简称“中拍协”， 于1995年6月在北京成立，是经中华人民国民政部批准，由全国拍卖企、事业单位、社会团体和从事拍卖或相关工作的个人，自愿结成的全国性、非营利性的社会团体组织，具有社会团体法人资格。</p>
					<img src="@/assets/images/progress2.png" alt=""/>
					<p>完备的线下服务体系“拍界”拥有精准客户群体，可以提供多种网上竞价的功能，还能提供专业完备的线下服务，“拍界”具有专业完备的线下服务体系。中国拍卖行业协会近2800余家会员单位，全国近7300余家拍卖企业,13000多名拍卖师，近20多万拍卖从业人员都是“拍界”的坚强后盾，可为委托单位、竞买群体、买受人提供优质的线下服务，完善的线下服务以及后期延续服务在全国范围内可无死角的延伸。</p> 
					<img src="@/assets/images/progress3.png" alt=""/>
					<p>精准竞买群体“拍界”拥有着精准的竞买客户群体，可以做到精准营销。参加平台上拍卖会的竞买群体相对稳定，各类标的均有常期参与的固定群体，平台积累了无数客户群体。除此之外，入驻平台的各拍卖企业会员，也有着自身的竞买群体资源，可以说“拍界”的竞买群体资源遍布全国各地市，甚至各区县。拍界的客户资源不仅精准，群体数量大，而且分布很广。</p>
					<img src="@/assets/images/progress4.png" alt=""/>
					<p>拍界在2020年火力全开，将更多简单便捷的平台政策送给用户，全方位开拓参拍者的拍卖之路。在疫情防护解除过去的半个月里，便有无数参拍者踊跃报名，把握拍卖时代风口，迎风破浪，共赴亿万蓝海。</p>
					<p>目前正值疫情期间，拍卖行业并没有受到很大影响，仍然有很多卖家通过各渠道了解拍界的相关事宜，从平台流量到品牌形象定位，都具备强大的实力和值得信赖的资质，正是因为平台资质过硬，才能成为无数个卖家的首要选择，其中陶瓷厂就是其中一个实例。</p>
					<img src="@/assets/images/progress1.png" alt=""/>
					<p>专业化服务队伍“拍界”有专业的技术支撑，自主创新强,研发多种网络拍卖方式，拍界有着强大的行业支持和资金支持，有着国内顶级的网络技术团队，随时根据市场的需求、企业的需求客户的需求进行系统的升级迭代、更新维护，使平台在保持专业性、稳定性的同时更人性化。</p>
					<img src="@/assets/images/progress6.png" alt=""/>
					<p>拍界真诚欢迎各位使用，拍界为您提供全面的二手设备，废旧金属、废旧电子电器等商品。公司诚信经营，以品质第一作为发展的第一准则，以热情周到的态度为您服务，让我们携手，走向拍卖经典时代！</p>
				</li>
			</ul> -->
		</div>
    <div class="problem_phone">
      <ul class="problem_left_title">
        <li class="problem_left_titles">拍卖流程常见问题</li>
        <li>如何报名参加竞拍？
          <ul class="problem_phone_content">
            <li>
              <img
                src="@/assets/images/jingpai.png"
                alt=""
              >
            </li>
          </ul>
        </li>
        <li>什么是流拍？
          <ul class="problem_phone_content">
            <li>
              <p>“流拍”是指在拍卖中，由于未达到系统设置的条件，造成的拍卖交易失败。</p>
            </li>
          </ul>
        </li>
        <li>什么是标的物？
          <ul class="problem_phone_content">
            <li>
              <p>标的物是指当事人双方权利义务指向的对象。商业买卖合同中会有的特定名词，标的物指买卖合同中所指的物体或商品。<br>举例说明，在房屋租赁中，标的物是所租赁的房屋。</p>
            </li>
          </ul>
        </li>

        <li
          class="problem_left_titles"
          id="pm_rule"
        >拍卖规则</li>
        <li>保证金规则？
          <ul class="problem_phone_content">
            <li>
              <p>1、保证金的缴纳：<br>
                <!-- 保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金（吉林省崇晟科贸有限公司开户行:{{$global.account_bank}}<span class="c_red">{{$global.account_number}}</span>）。 -->
                保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金。
                <br> 2、保证金的返还：<br>A.用户未成功竞拍商品：保证金返还时限为5个工作日。B.用户竞拍成功后，送拍人主动关闭交易或未履约发货或因商家其他原因导致交易未完成的；竞拍结束后，系统会自动在5个工作日内将款项退还到支付账号中。C.注：竞拍人缴纳的保证金仅用于履约保证，返还时不计利息，请知悉<br>3、保证金的扣除：<br> A.在升价竞拍成功之时起的5个工作日内未按照成交价格支付货款的。 B.送拍机构主动关闭交易或未履行发货协议而导致交易未完成的。 C.标的物流拍之后，送拍人打算重新拍卖的。<br>4、保证金抵佣金：<br> 用户竞拍成功后，竞买保证金即转为成交保证金,用户完成标的交割手续后，保证金将全部或部分抵扣佣金。如保证金金额小于应支付佣金金额，用户应立即补齐；如保证金金额大于应支付佣金金额，平台将于扣除佣金后5个工作日内将剩余保证金无息返还用户。</p>
            </li>
          </ul>
        </li>
        <li>拍卖成交规则？
          <ul class="problem_phone_content">
            <li>
              <p>拍卖采取有保留价或无保留价的增价拍卖方式，每次出价金额必须是加价幅度规定金额的整数倍。<br>1.有保留价：至少一人报名且出价不低于保留价，方可成交，出价低于保留价时，标的流拍；<br>2.无保留价：① 一人报名，即视为接受标的底价，已满足成交条件，即可成交。② 无人报名，标的流拍。③ 两人或两人以上报名，均未出价，最先报名成功者判定为买受人。<br>【注】在拍卖状态下为了防止恶意抬价，第一个出价人限制自己加价,需等其他竞拍人出价后,才能继续出价.<br>【注】在拍卖状态下为了防止恶意抬价，第一个出价人限制自己加价,需等其他竞拍人出价后,才能继续出价.</p>
            </li>
          </ul>
        </li>
        <li>拍卖延时规则？
          <ul class="problem_phone_content">
            <li>
              <p>1)出价延时的概念<br> 出价延时是指，当标的物的竞拍时间只剩最后1分钟时，如果有竞买人出价竞拍，那么系统将会自动延长拍品的竞拍时间。<br>2)出价延时的基本规则<br>在设置了出价延时的拍品竞拍结束的前1分钟（以系统接受竞价的时间显示为准），如果有竞买人出价竞拍，那么该次拍卖时间在此次出价的时间的基础上自动延时1分钟，循环往复直到没有竞买人出价竞拍时，拍卖结束。<br>3)出价延时举例说明<br>比如：假设某件拍品的拍卖结束时间是8月8日22点整，如果在8月8日21点58分15秒，有竞买人出价，那么系统将拍卖结束时间自动延长至8月8日22点02分15秒；如果在22点03分有竞买人出价，那么系统将自动延时到22点05分……以此类推，直到最后两分钟没有新的竞买人出价，那么该拍品的竞拍结束。<br>4)出价延时的效果<br>出价延时给拍卖用户带来的便利包括以下几点：<br> 1.将给到竞买人更加充分的参与竞拍的机会。<br>2.避免因为网络或者电脑原因导致的延迟而错失出价机会。</p>
            </li>
          </ul>
        </li>
        <li>重新拍卖规则？
          <ul class="problem_phone_content">
            <li>
              <p>参重新拍卖是指拍卖成交后，发现有下列情形的，处置方可以决定重新拍卖。<br>1)买受人未支付价款致使拍卖目的难以实现的；<br>2)竞买人之间恶意串通的；<br>3)其他违反有关法律规定应当重新拍卖的。</p>
            </li>
          </ul>
        </li>

        <li class="problem_left_titles">其他常见问题</li>
        <li>悔拍怎么办？
          <ul class="problem_phone_content">
            <li>
              <p>竞拍成功前您的保证金是会转账到拍卖机构的指定账户中，如果竞拍到了商品没有付尾款的话，买受人悔拍后保证金不予退还。</p>
            </li>
          </ul>
        </li>
        <li>如何办理资产交割？
          <ul class="problem_phone_content">
            <li>
              <p>竞买人竞买成功之后，在“我的竞拍”-“我的中心”-“我的订单”里查询应该补缴的货物尾款（账户信息与缴纳保证金账户信息一致）；付完尾款之后，竞买人凭相关证件及付款凭证在3个工作日内与送拍人办理相关的资产交割手续，在此期间平台方将在线下给予相应的支持。</p>
            </li>
          </ul>
        </li>

        <!-- <li class="problem_left_titles">关于拍界</li>
				<li>关于拍界？
					<ul class="problem_phone_content">
						<li>
							<p>由中国拆迁网设计打造的全国性综合型网络拍卖平台国内更专业更齐全的拍卖平台，秉承拍卖物品质量第一的经营理念，无数物品以及资产，包罗万象，您既可以作为拍卖方，也可以作为竞拍者，卖到最开心的价格，买到最放心的产品。物资拍卖，一网打尽！</p>
							<p>拍卖流程 </p>
							<p>首先第一步注册实名认证，拍前准备，报名交保证金，出价竞拍，竞拍成功，办理交割，拍卖流程简单便捷！</p>
							<img src="@/assets/images/progress1.png" alt=""/>
							<img src="@/assets/images/progress2.png" alt=""/>
							<p>完备的线下服务体系“拍界”拥有精准客户群体，可以提供多种网上竞价的功能，还能提供专业完备的线下服务，“拍界”具有专业完备的线下服务体系。中国拍卖行业协会近2800余家会员单位，全国近7300余家拍卖企业,13000多名拍卖师，近20多万拍卖从业人员都是“拍界”的坚强后盾，可为委托单位、竞买群体、买受人提供优质的线下服务，完善的线下服务以及后期延续服务在全国范围内可无死角的延伸。</p> 
							<p>精准竞买群体“拍界”拥有着精准的竞买客户群体，可以做到精准营销。参加平台上拍卖会的竞买群体相对稳定，各类标的均有常期参与的固定群体，平台积累了无数客户群体。除此之外，入驻平台的各拍卖企业会员，也有着自身的竞买群体资源，可以说“拍界”的竞买群体资源遍布全国各地市，甚至各区县。拍界的客户资源不仅精准，群体数量大，而且分布很广。</p>
							<p>专业化服务队伍“拍界”有专业的技术支撑，自主创新强,研发多种网络拍卖方式，拍界有着强大的行业支持和资金支持，有着国内顶级的网络技术团队，随时根据市场的需求、企业的需求客户的需求进行系统的升级迭代、更新维护，使平台在保持专业性、稳定性的同时更人性化。</p>
							<p>拍界真诚欢迎各位使用，拍界为您提供全面的二手设备，废旧金属、废旧电子电器等商品。公司诚信经营，以品质第一作为发展的第一准则，以热情周到的态度为您服务，让我们携手，走向拍卖经典时代！</p>
						</li>
					</ul>
				</li> -->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界App，拍界官网，捡漏，拍卖，拍卖网，拍卖会，手机拍卖，微拍，微信拍卖，寻宝，收藏，拆除，二手设备，工厂，废旧物资，再生资源，回收，法拍房，法拍车，房产，司法拍"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      problemtabs: [
        { tab: '如何报名参加竞拍？' },
        { tab: '什么是流拍？' },
        { tab: '什么是标的物？' }
      ],
      problemtabs1: [
        { tab: '保证金规则？' },
        { tab: '拍卖成交规则？' },
        { tab: '拍卖延时规则？' },
        { tab: '重新拍卖规则？' },
      ],
      problemtabs2: [
        { tab: '悔拍怎么办？' },
        { tab: '如何办理资产交割？' },
      ],
      problemtabs3: [
        { tab: '拍界' },
      ],

      showUl: 0,
      showLi: 0
    }
  },
  created () {
    // 接收路由参数
    const curLi = this.$route.query.curLi;
    const curUl = this.$route.query.curUl;
    if (curLi !== undefined && curUl !== undefined) {
      this.toggleproTabs(curLi, curUl)
    }
  },
  methods: {
    // tab切换
    toggleproTabs: function (showLi, showUl) {
      this.showLi = showLi;
      this.showUl = showUl;
    }
  },
  mounted () {
    // 不是移动端则页面至顶部
    if (this.$route.query.isMobile == false) {
      window.scrollTo(0, 0)
    } else {
      document.getElementById('pm_rule').scrollIntoView();
    }
  }
}
</script>
